export default {
  saveFilters (filters) {
    const keys = Object.keys(filters)
    const blocked = ['options']
    return !keys.some(key => blocked.includes(key))
  }
}
